import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";

const EyeIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const ShieldIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const LockIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const MonitorIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const FEATURES = [
  {
    icon: <EyeIcon />,
    title: "Deep Visibility",
    desc: "See every device, connection, and app in real time",
  },
  {
    icon: <ShieldIcon />,
    title: "Threat Blocking",
    desc: "Automatically blocks malicious domains, ads, and intrusion attempts",
  },
  {
    icon: <LockIcon />,
    title: "Remote VPN",
    desc: "Spin up a secure VPN in one tap to reach your network",
  },
  {
    icon: <MonitorIcon />,
    title: "MSP Management",
    desc: "Manage all boxes, users, rules, and reports from a single console",
  },
];

const Crystal: FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles["page"]}>
      <div className={styles["hero"]}>
        <div className={styles["container"]}>
          <div className={styles["eyebrow"]}>
            <span>🔥</span>
            <span>Firewalla for Crystal</span>
          </div>
          <h1 className={styles["headline"]}>
            Zero Trust Cyber security
            <br />
            <span className={styles["headline-accent"]}>on any hardware.</span>
          </h1>
          <p className={styles["subtitle"]}>
            Run Firewalla Crystal on your own devices. Deep network visibility,
            real-time threat blocking, and remote VPN — managed centrally through
            MSP.
          </p>
          <button
            className={styles["cta-button"]}
            onClick={() => navigate("/crystal/success")}
          >
            Buy License · $99
          </button>
        </div>
      </div>

      <div className={styles["features-section"]}>
        <div className={styles["container"]}>
          <p className={styles["features-label"]}>CORE FEATURES</p>
          <div className={styles["features-grid"]}>
            {FEATURES.map((f) => (
              <div key={f.title} className={styles["feature-card"]}>
                <div className={styles["feature-icon-wrap"]}>{f.icon}</div>
                <h3 className={styles["feature-title"]}>{f.title}</h3>
                <p className={styles["feature-desc"]}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crystal;
